<template>
  <div>
    <Card class="cardData">
      <Card v-show="manualAlert.length" tile flat v-for="item in manualAlert" :key="item._id">
        <v-divider></v-divider>
          <v-flex md12>
            <v-layout>
              <v-flex md12 xs6 ml-4 class="text-xs-left">
                <div pt-1 class="try--text">{{ item.equipment }}</div>
                <div>{{ item.message }}</div>
              </v-flex>
              <v-flex md12 xs6 pt-2 ml-4 class="text-xs-left">
                {{ $t('Created Time') }}{{ item.resolved_time ? ` - ${$t('Resolved Time')}` : '' }}
                {{ item.created_time }}{{ item.resolved_time ? ` - ${item.resolved_time}` : '' }}
              </v-flex>
            </v-layout>
          </v-flex>
      </Card>
      <v-layout v-show="!manualAlert.length" row justify-center align-center fill-height>
        <div>
          <v-icon size="50" color="accent">
            warning
          </v-icon>
        </div>
        <div class="no-alert">
          {{ $t('NO ALERTS') }}
        </div>
      </v-layout>
    </Card>
    <div class="pagination text-xs-center ">
      <v-pagination v-show="totalPages > 1" v-model="currentPage" :length="totalPages"
        dark color="accent" :total-visible="8" prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right" circle></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
const moment = require('moment')
const momentTz = require('moment-timezone')

import CommonApi from '@/services/Common'
import { EventBus } from '@/services/event-bus'
import { mixin, mapGettersMixin } from '@/util/mixin/index'
import Alert from '@/services/Alert'

const Graph = () => import('@/components/dashboard-inverter/Graph')
const SideCard = () => import('@/components/dashboard-inverter/SideCard')

export default {
  mixins: [mixin, mapGettersMixin],
  props: {
    dateFrom: {
      type: String,
      default: ''
    },
    dateTo: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      block_selected: null,
      inverter_room_list: [],
      manualAlert: [],
      currentPage: 1,
      totalItems: 10,
      totalOutput: null,
      isNext: false,
      value: null,
      loading: false
    }
  },
  components: {
    Graph,
    SideCard
  },
  computed: {
    ...mapGetters([
      'getActivePlantTimezone',
      'getSelectedPlantId'
    ]),
    dateString() {
      return `${this.dateFrom}||${this.dateTo}`
    },
    totalPages() {
      let pages = 0
      if (this.totalOutput) {
        pages = Math.floor(this.totalOutput / this.totalItems)
        if (this.totalOutput % this.totalItems > 0) {
          pages++
        }
      }
      return pages
    }
  },
  created() {
    EventBus.$on('graph-click', this.onManualAlert)
  },
  beforeDestroy() {
    this.SET_MAP_REDIRECT_BLOCK(false)
    EventBus.$off('graph-click', this.onManualAlert)
  },
  methods: {
    ...mapMutations(['SET_MAP_REDIRECT_BLOCK']),
    previous() {
      if (this.currentPage > 1) this.currentPage -= 1
    },
    next() {
      if (this.isNext) this.currentPage += 1
    },
    change(id) {
      this.block_selected = id
    },
    addLineBreak(message) {
      return message.replace(/\n/g, '<br />')
    },
    async getInverterRoomList() {
      if (this.getSelectedPlantId && this.block_selected) {
        let response = await CommonApi.getIdList(
          this.getSelectedPlantId,
          'inverter',
          2,
          this.block_selected
        )

        if (response.status === 200) {
          this.inverter_room_list = response.data.message
        }
      }
    },
    onManualAlert(value) {
      this.value = value
      const clickArea = value.xAxisData[value.eventIndex]
      this.loading = true
      const tz = this.getActivePlantTimezone
      if (
        momentTz(this.dateTo).tz(tz).format('YYYY-MM-DD') ===
        momentTz(this.dateFrom).tz(tz).format('YYYY-MM-DD')
      ) {
        Alert.getManualAlertListV2(
          this.getSelectedPlantId,
          'computed',
          'MA',
          'time',
          momentTz(`${this.dateTo} ${clickArea}:00:00`,
            'YYYY-MM-DD HH:mm:ss').tz(tz).format('X'),
          momentTz(`${this.dateFrom} ${clickArea}:59:59`,
            'YYYY-MM-DD HH:mm:ss').tz(tz).format('X'),
          this.currentPage,
          this.totalItems
        )
          .then((res) => {
            this.manualAlert = res.data.result.finalOutput
            this.totalOutput = res.data.result.count
            this.isNext =
              this.currentPage * this.totalItems < res.data.result.count
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            console.log(err)
          })
      } else if (
        momentTz(this.dateTo).tz(tz).format('YYYY-MM-DD') <
        momentTz(this.dateFrom).tz(tz).format('YYYY-MM-DD')
      ) {
        Alert.getManualAlertListV2(
          this.getSelectedPlantId,
          'computed',
          'MA',
          'date',
          moment(clickArea).format('YYYY-MM-DD'),
          null,
          this.currentPage,
          this.totalItems
        )
          .then((res) => {
            this.manualAlert = res.data.result.finalOutput
            this.totalOutput = res.data.result.count
            this.isNext =
              this.currentPage * this.totalItems < res.data.result.count
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            console.log(err)
          })
      }
    }
  },
  watch: {
    dateString() {
      this.manualAlert = []
    },
    block_selected() {
      this.getInverterRoomList()
      this.$emit('update:invRoomList', this.inverter_room_list)
    },
    getSelectedPlantId() {
      this.block_selected = null
      this.currentPage = 1
      this.totalOutput = null
      this.manualAlert = []
    },
    totalOutput() {
      if (this.totalPages > 1) {
        document.querySelector('.cardData').style.height = '43rem'
      } else {
        document.querySelector('.cardData').style.height = '46rem'
      }
    },
    currentPage() {
      this.onManualAlert(this.value)
    }
  }
}
</script>

<style scoped>
.cardData {
  height: 46rem;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 14px;
}

.no-alert {
  font-size: 1.5rem;
  font-weight: bold;
}

</style>
